export const buildQueryString = data => {
  return new URLSearchParams(
    Object.entries(data).filter(([_, v]) => v != null)
  ).toString();
};

export const fetchJsonWithCredentialsOptions = {
  headers: {
    Accept: 'application/json',
    'Content-Type': 'application/json',
  },
  credentials: 'include',
};
